import Swiper from 'swiper';
import 'regenerator-runtime/runtime';
import './plugins/accordion.plugin';
import './plugins/dropdown.plugin';
import './plugins/mobileNavigation.plugin';
import './plugins/stickyElement.plugin';
import './plugins/stickyHeader.plugin';
import './plugins/tabs.plugin';

import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

import "bootstrap";


$(() => {
    //move page down for fixed header
    $('main[role=main]').css('padding-top', $('nav.navbar').outerHeight())

    $(window).on( 'resize orientationchange load', function() {
        $('main[role=main]').css('padding-top', $('nav.navbar').outerHeight())
    });

    // mobile menu open subnav
    $('.nav-link.-hasDropdown').on('click', function(e) {
        if ($(window).width() <= 1023) {
            if (!$(this).hasClass('-clickable')) {
                e.preventDefault()
                $('.-subnavOpen').removeClass('-subnavOpen')
                $(this).parent().addClass('-subnavOpen')
                // $(this).parent('li').siblings('.menu-item-has-children').children('.-clickable').removeClass('-clickable')
                $('.-clickable').removeClass('-clickable')
                $(this).addClass('-clickable')
            }
        }
    });

    $(window).scroll(function(){
        if ($(window).scrollTop() > 10){
            $('nav.navbar').addClass('-scrolled')
        } else if ( $('nav.navbar').hasClass('-scrolled') ) {
            $('nav.navbar').removeClass('-scrolled')
            setTimeout( function() {
                $('main[role=main]').css('padding-top', $('nav.navbar').outerHeight())
            }, 300);
        }
    })



    //hero video settings
    if( $( '.hero video' ).length ) {
        var vid = $( '.hero video' );
        if (window.matchMedia('(prefers-reduced-motion)').matches) {
            vid.removeAttribute("autoplay");
            vid.pause();
        }
    }


    // make pdfs open in new window
    $('a[href$=".pdf"], a[href$=".PDF"], a[href$=".doc"], a[href$=".DOC"], a[href$=".docx"], a[href$=".DOCX"]').attr('target', '_blank')


    //intialize introduction slider
    if( $( '.introduction-container' ).length ) {
        var introductionSwiper = new Swiper('.introduction-container', {
            init: false,
            loop: true,
            navigation: {
                nextEl: '.introduction-container .swiper-button-next',
                prevEl: '.introduction-container .swiper-button-prev',
            },
            pagination: {
                el: '.introduction-container .swiper-pagination',
                type: 'fraction',
            },
        });
        introductionSwiper.on('slideChangeTransitionEnd init', function () {
            if ( $('.introduction-container .slider__navigation').hasClass('-dark') && !$('.introduction-container .swiper-slide-active').hasClass('-dark') ) {
                $('.introduction-container .slider__navigation').removeClass('-dark')
            } else if ( $('.introduction-container  .swiper-slide-active').hasClass('-dark') ) {
                $('.introduction-container .slider__navigation').addClass('-dark')
            }
        })
        introductionSwiper.init()
    }

    //intialize twoColumnSlider
    if( $( '.twoColumnSlider-container' ).length ) {
        var twoColumnSwiper = new Swiper('.twoColumnSlider-container', {
            init: false,
            loop: true,
            navigation: {
                nextEl: '.twoColumnSlider-container .swiper-button-next',
                prevEl: '.twoColumnSlider-container .swiper-button-prev',
            },
            pagination: {
                el: '.twoColumnSlider-container .swiper-pagination',
                type: 'fraction',
            },
        });
        twoColumnSwiper.on('slideChangeTransitionEnd init', function () {
            if ( $('.twoColumnSlider-container .slider__navigation').hasClass('-dark') && !$('.twoColumnSlider-container .swiper-slide-active').hasClass('-dark') ) {
                $('.twoColumnSlider-container .slider__navigation').removeClass('-dark')
            } else if ( $('.twoColumnSlider-container  .swiper-slide-active').hasClass('-dark') ) {
                $('.twoColumnSlider-container .slider__navigation').addClass('-dark')
            }
        })
        twoColumnSwiper.init()
    }

    //intialize imageSlider
    if( $( '.imageSlider-container' ).length ) {
        var imageSwiper = new Swiper('.imageSlider-container', {
            init: false,
            loop: true,
            navigation: {
                nextEl: '.imageSlider-container .swiper-button-next',
                prevEl: '.imageSlider-container .swiper-button-prev',
            },
            pagination: {
                el: '.imageSlider-container .swiper-pagination',
                type: 'fraction',
            },
        });
        imageSwiper.on('slideChangeTransitionEnd init', function () {
            if ( $('.imageSlider-container .slider__navigation').hasClass('-dark') && !$('.imageSlider-container .swiper-slide-active').hasClass('-dark') ) {
                $('.imageSlider-container .slider__navigation').removeClass('-dark')
            } else if ( $('.imageSlider-container  .swiper-slide-active').hasClass('-dark') ) {
                $('.imageSlider-container .slider__navigation').addClass('-dark')
            }
        })
        imageSwiper.init()
    }

    //intialize testimonial slider
    if( $( '.testimonials-container' ).length ) {
        var testimonialsSwiper = new Swiper('.testimonials-container', {
            init: false,
            loop: true,
            navigation: {
                nextEl: '.testimonials-container .swiper-button-next',
                prevEl: '.testimonials-container .swiper-button-prev',
            },
            pagination: {
                el: '.testimonials-container .swiper-pagination',
                type: 'fraction',
            },
        });
        testimonialsSwiper.on('slideChangeTransitionEnd init', function () {
            if ( $('.testimonials-container .slider__navigation').hasClass('-dark') && !$('.testimonials-container .swiper-slide-active').hasClass('-dark') ) {
                $('.testimonials-container .slider__navigation').removeClass('-dark')
            } else if ( $('.testimonials-container  .swiper-slide-active').hasClass('-dark') ) {
                $('.testimonials-container .slider__navigation').addClass('-dark')
            }
        })
        testimonialsSwiper.init()
    }

    // Models carousel: init per block so nav targets the correct wrapper (not other Swipers on the page)
    $('.cardSlider__wrapper').each(function () {
        const $wrapper = $(this);
        const $scroller = $wrapper.find('.js-cardScroller');
        if (!$scroller.length) {
            return;
        }

        const slideCount = $scroller.find('.swiper-slide').length;
        const $next = $wrapper.find('.swiper-button-next');
        const $prev = $wrapper.find('.swiper-button-prev');

        if (slideCount > 3 && $next.length && $prev.length) {
            new Swiper($scroller[0], {
                loop: false,
                watchOverflow: true,
                navigation: {
                    nextEl: $next[0],
                    prevEl: $prev[0],
                },
                breakpoints: {
                    300: {
                        slidesPerView: 1.5,
                        spaceBetween: 48,
                    },
                    576: {
                        slidesPerView: 2,
                        spaceBetween: 48,
                    },
                    1024: {
                        slidesPerView: 3,
                        spaceBetween: 64,
                    }
                },
                simulateTouch: true
            });
        } else {
            $scroller.addClass('-noSlider');
        }
    });

    //intialize gallery slider (nav is sibling of .gallery-container inside .gallery-slider)
    if ($('.gallery-slider').length) {
        const $wrap = $('.gallery-slider').first();
        const $galleryEl = $wrap.find('.gallery-container');
        const galleryRoot = $galleryEl[0];
        const slideCount = $galleryEl.find('.swiper-slide').length;

        if (galleryRoot && slideCount) {
            const prevBtn = $wrap.find('.swiper-button-prev')[0];
            const nextBtn = $wrap.find('.swiper-button-next')[0];

            const galleryConfig = {
                loop: false,
                watchOverflow: true,
                centeredSlides: false,
                spaceBetween: 24,
                slidesPerView: 1,
                breakpoints: {
                    992: {
                        slidesPerView: Math.min(3, slideCount),
                        spaceBetween: 32,
                        centeredSlides: false,
                    },
                },
            };
            if (nextBtn && prevBtn) {
                galleryConfig.navigation = {
                    nextEl: nextBtn,
                    prevEl: prevBtn,
                };
            }

            var gallerySwiper = new Swiper(galleryRoot, galleryConfig);

        // add nav in modals
        $('.modal-button-prev').on('click', function(){
            prevModal()
        })
        $('.modal-button-next').on('click', function(){
            nextModal()
        })

        $(document).keydown(function(e){
            if (e.which == 37) { 
                e.preventDefault()
                prevModal()
            }
        })

        $(document).keydown(function(e){
            if (e.which == 39) { 
                e.preventDefault()
                nextModal()
            }
        })

        function prevModal() {
            const currentModal = $('.modal.show');
            if ( currentModal.prev('.modal').length ) {
                gallerySwiper.slidePrev()
                currentModal.modal('hide')
                currentModal.prev('.modal').modal('show')
            } else {
                gallerySwiper.slidePrev()
                currentModal.modal('hide')
                currentModal.siblings('.-last').modal('show')
            }
        }

        function nextModal() {
            const currentModal = $('.modal.show');
            if ( currentModal.next('.modal').length ) {
                gallerySwiper.slideNext()
                currentModal.modal('hide')
                currentModal.next('.modal').modal('show')
            } else {
                gallerySwiper.slideNext()
                currentModal.modal('hide')
                currentModal.siblings('.-first').modal('show')
            }
        }
        }
    }

    // pause video on modal close
    $('[data-toggle="modal"]').on('click', function(){
        // get link's modal target
        var modalTarget = $(this).data('target');

        // if modal has an iframe
        if ( !$(modalTarget).find('iframe').length == 0 ) {

            // get iframe and src
            var modalIframe = $(modalTarget).find('iframe');
            var modalIframeSrc = $(modalIframe).attr('src');

            // set src attribute on close to ensure video stops playing
            $(modalTarget).on('hide.bs.modal', function (e) {
                $(modalIframe).attr('src', modalIframeSrc);
            });

            // set src attribute on open
            $(modalTarget).on('show.bs.modal', function (e) {
                $(modalIframe).attr('src', modalIframeSrc);
            });
        }
    });

    //initialize relatedProducts slider

    if( $( '.relatedProducts-container' ).length && $('.relatedProducts-container .swiper-slide').length > 2) {
        const $relContainer = $('.relatedProducts-container').first();
        const relRoot = $relContainer[0];
        const $relWrap = $relContainer.closest('.twoColumn__relatedProducts-wrapper');
        const $relNav = $relWrap.find('.slider__navigation');
        const relNext = $relNav.find('.swiper-button-next')[0];
        const relPrev = $relNav.find('.swiper-button-prev')[0];

        // Calculate and set container width
        const setContainerWidth = () => {
            const container = document.querySelector('.twoColumn__right');
            const swiperWrapper = relRoot.querySelector('.swiper-wrapper');
            if (container && swiperWrapper) {
                const width = container.getBoundingClientRect().width;
                const computedStyle = window.getComputedStyle(container);
                const paddingRight = parseInt(computedStyle.paddingRight, 10);
                const adjustedWidth = width - paddingRight;
                swiperWrapper.style.setProperty('--container-width', `${adjustedWidth}px`);
                // Also set it on the container level just in case
                container.style.setProperty('--container-width', `${adjustedWidth}px`);
            }
        };

        // Set initial width
        setContainerWidth();

        // Update on resize
        window.addEventListener('resize', setContainerWidth);

        const relatedConfig = {
            init: false,
            slidesPerView: 1,
            spaceBetween: 32,
            breakpoints: {
                768: {
                    slidesPerView: 2,
                }
            },
            on: {
                init: function () {
                    this.update();
                    setContainerWidth(); // Also set width on init
                },
                resize: function () {
                    this.update();
                    setContainerWidth(); // Also set width on resize
                }
            }
        };
        if (relNext && relPrev) {
            relatedConfig.navigation = {
                nextEl: relNext,
                prevEl: relPrev,
            };
        }

        var relatedProductsSwiper = new Swiper(relRoot, relatedConfig);
        
        $(document).ready(() => {
            relatedProductsSwiper.init();
        });
    } else if( $( '.relatedProducts-container' ).length && $('.relatedProducts-container .swiper-slide').length <= 2) {
        $('.relatedProducts-container').addClass('-noSlider');
    }

    // Initialize mobile sliders (blogPosts and logoGrid)
    const initializeMobileSlider = (selector) => {
        if ($(selector).length) {
            let swiper;
            
            const initializeSwiper = () => {
                if (window.innerWidth < 768 && !swiper) {
                    swiper = new Swiper(selector, {
                        slidesPerView: 1.25,
                        spaceBetween: 16,
                        grabCursor: true,
                    });
                } else if (window.innerWidth >= 768 && swiper) {
                    swiper.destroy();
                    swiper = undefined;
                }
            };

            // Initialize
            initializeSwiper();

            // Re-initialize on resize
            window.addEventListener('resize', initializeSwiper);
        }
    };

    // Initialize both sliders
    initializeMobileSlider('.blogPosts__grid');
    initializeMobileSlider('.twoColumn__logoGrid');

    if ($('.accordion').length) {
        $('.accordion').accordion({
            hiddenOnLoad: true,
            singleOpen: false,
        });
    }
});